import { cardsData } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-500/10 border border-primary-500/20 text-xs font-medium text-primary-400 mb-3">
            <i className="ri-movie-2-line"></i>
            编辑力荐
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">热映推荐</h2>
          <p className="mt-2 text-sm text-foreground-500">高分佳作，不容错过</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {cardsData.map((item, idx) => (
            <div
              key={item.id}
              className={`group rounded-2xl bg-background-100 border border-background-200/60 overflow-hidden hover:border-primary-500/30 transition-all duration-300 ${
                idx === 0 ? 'lg:col-span-2 lg:row-span-2' : ''
              }`}
            >
              <div className={`relative overflow-hidden ${idx === 0 ? 'aspect-[16/9]' : 'aspect-[2/3]'}`}>
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-100/90 via-background-100/20 to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-1 rounded-lg bg-primary-500 text-background-50 text-xs font-bold">{item.rating}</span>
                </div>
                <div className="absolute bottom-3 left-3 right-3">
                  <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 mb-1">{item.title}</h3>
                  <div className="flex items-center gap-2 text-xs text-foreground-400">
                    <span>{item.year}</span>
                    <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
                    <span>{item.genre}</span>
                  </div>
                </div>
              </div>
              {idx !== 0 && (
                <div className="p-3">
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}